import { render, staticRenderFns } from "./EmpresasMain.vue?vue&type=template&id=70c99da2"
import script from "./EmpresasMain.vue?vue&type=script&lang=js"
export * from "./EmpresasMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports